import { Schema, NodeSpec, MarkSpec } from 'prosemirror-model';

const nodes: NodeSpec = {
   doc: {
      content: 'block+',
   },

   paragraph: {
      content: 'inline*',
      marks: '_',
      group: 'block',
      parseDOM: [{ tag: 'p' }],
      toDOM() {
         return ['p', 0];
      },
   },

   text: {
      group: 'inline',
      toDOM(node: any) {
         return node.text;
      },
   },
};

const marks: MarkSpec = {
   em: {
      parseDOM: [
         { tag: 'i' },
         { tag: 'em' },
         // @ts-expect-error ts-migrate(7011) FIXME: Function expression, which lacks return-type annot... Remove this comment to see the full error message
         { style: 'font-style', getAttrs: (value: any) => value == 'italic' && null },
      ],
      toDOM() {
         return ['em'];
      },
   },

   strong: {
      parseDOM: [
         { tag: 'strong' },
         // @ts-expect-error ts-migrate(7011) FIXME: Function expression, which lacks return-type annot... Remove this comment to see the full error message
         { tag: 'b', getAttrs: (node: any) => node.style.fontWeight != 'normal' && null },
         {
            style: 'font-weight',
            // @ts-expect-error ts-migrate(7011) FIXME: Function expression, which lacks return-type annot... Remove this comment to see the full error message
            getAttrs: (value: any) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null,
         },
      ],
      toDOM() {
         return ['strong'];
      },
   },

   underline: {
      parseDOM: [
         { tag: 'u' },
         // @ts-expect-error ts-migrate(7011) FIXME: Function expression, which lacks return-type annot... Remove this comment to see the full error message
         { style: 'text-decoration', getAttrs: (value: any) => value == 'underline' && null },
      ],
      toDOM() {
         return ['u'];
      },
   },

   link: {
      attrs: {
         href: {},
         title: { default: null },
         target: { default: null },
      },
      inclusive: false,
      parseDOM: [
         {
            tag: 'a[href]',
            getAttrs(dom: any) {
               return {
                  href: dom.getAttribute('href'),
                  title: dom.getAttribute('title'),
                  target: dom.getAttribute('target'),
               };
            },
         },
      ],
      toDOM(node: any) {
         return ['a', node.attrs];
      },
   },
};

const schema = new Schema({ nodes, marks });

export default {
   nodes,
   marks,
   schema,
};
